
import { mapState } from 'vuex'
export default {
    name: 'ApplyDeposit',
    middleware: ['checkAuth'],
    data: () => ({
        valid: false,
        bankAccountId: '',
        rate: '',
        isPromotionValid: {
            status: true,
            text: null,
        },
    }),
    computed: {
        ...mapState({
            promotionId: (state) => state.promotion.promotionId,
        }),
    },
    async mounted() {
        await this.$store.dispatch('promotion/promotionId')
        this.id = this.$route.query.promotionId
    },
}
